import { Helmet } from "react-helmet-async";

const ORG_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "NonprofitOrganization",
  name: "Tales&Legends gUG",
  url: "https://talesandlegends.org",
  logo: "https://talesandlegends.org/assets/brand/logo-mark.svg",
  sameAs: ["https://www.instagram.com/tales.wtf", "https://discord.gg/6Xw4fycXBc"],
  contactPoint: {
    "@type": "ContactPoint",
    email: "hello@talesandlegends.org",
    contactType: "customer support",
    areaServed: "DE",
    availableLanguage: ["de", "en"],
  },
  // Freital, not Dresden: the legally registered seat per the Impressum
  // (Reiboldschachtring 28, 01705 Freital) — this previously said "Dresden"
  // here, a real NAP inconsistency against the Impressum/Info pages that
  // undermines local-search trust and would block a future Google Business
  // Profile claim. Marketing copy elsewhere intentionally still leads with
  // "Dresden and Saxony" as the service area, which is a separate, valid
  // framing decision from what this structured, machine-read address claims.
  address: {
    "@type": "PostalAddress",
    streetAddress: "Reiboldschachtring 28",
    postalCode: "01705",
    addressLocality: "Freital",
    addressCountry: "DE",
  },
};

export default function OrganizationJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ORG_JSON_LD)}</script>
    </Helmet>
  );
}
